import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_MDC_STOCK_POSTING_ITEM,
  SOFTLINE_API_MDC_STOCK_POSTING_ITEMS,
} from '../mdc-stock-posting.api';
import {
  StockPostingItem,
  StockPostingItemPatch,
  StockPostingItemPost,
} from '../types/stock-posting-item';

@Injectable()
export class StockPostingItemRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  load(stockPostingId: number): Promise<StockPostingItem[]> {
    return this.dataAccess.get<StockPostingItem[]>({
      path: SOFTLINE_API_MDC_STOCK_POSTING_ITEMS,
      pathParams: { id: stockPostingId },
    });
  }

  create(stockPostingId: number, body: StockPostingItemPost): Promise<StockPostingItem> {
    return this.dataAccess.create<StockPostingItemPost, StockPostingItem>(
      { path: SOFTLINE_API_MDC_STOCK_POSTING_ITEMS, pathParams: { id: stockPostingId } },
      body
    );
  }

  patch(
    stockPostingId: number,
    itemId: number,
    body: Partial<StockPostingItemPatch>
  ): Promise<StockPostingItem> {
    return this.dataAccess.patch<Partial<StockPostingItemPatch>, StockPostingItem>(
      {
        path: SOFTLINE_API_MDC_STOCK_POSTING_ITEM,
        pathParams: { id: stockPostingId, itemId },
      },
      body
    );
  }

  delete(stockPostingId: number, itemId: number): Promise<void> {
    return this.dataAccess.delete<void>({
      path: SOFTLINE_API_MDC_STOCK_POSTING_ITEM,
      pathParams: { id: stockPostingId, itemId },
    });
  }
}
